<script>
export default {
  name: 'CpTagIcon',
  components: {
    CpBaseSvgIcon: require('../base-svg-icon').default,
  },
  props: {
    tag: { type: String, default: '' },
    iconOnly: { type: Boolean, default: false },
    optionTag: { type: Boolean, default: false },
    height: Number,
    width: Number,
  },
  computed: {
    tagIcon() {
      if (this.tag !== 'Transportation / Infrastructure') {
        const tagIconName = this.tag.replace(/\s+/g, '-').toLowerCase().replace(/\//g, '');
        return () => import(`./icons/${tagIconName}`);
      } else {
        const tagIconName = this.tag.replace(/\s+/g, '').toLowerCase().replace(/\//g, '-');
        return () => import(`./icons/${tagIconName}`);
      }
    },
    tagClass() {
      if (['internet-policy', 'union-rights', 'income-inequality', 'health-care', 'public-education', 'transportation-infrastructure'].includes(this.tag)) {
        return 'tag-icon-sm';
      }
    },
  },
};
</script>

<template>
  <span v-if="iconOnly && optionTag">
    <component class="option-tag-icon" :class="tagClass" v-bind:is="tagIcon" :height="height && height" :width="width && width" />
  </span>
  <span v-else-if="iconOnly">
    <component class="icon" :class="tagClass" v-bind:is="tagIcon" :height="height && height" :width="width && width" />
  </span>
  <span v-else class="tag-icon-content">
    <component :class="tagClass" v-bind:is="tagIcon" :height="height && height" :width="width && width" />
    <span class="tag-name">{{ tag }}</span>
  </span>
</template>

<style scoped>
.tag-icon-content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
svg.tag-icon-sm {
  height: 24px;
  width: 24px;
}
.option-tag-icon {
  height: 26px;
  width: 26px;
  width: auto;
  margin-left: -4px;
}
</style>
